import { IoChevronBack } from "react-icons/io5";
import { LinkifyText } from '../compornents/LinkifyText';
/* eslint-disable no-unused-vars */
import { useState, useEffect, } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Analytics, Gtag } from '../compornents/Analytics';
import { useModal } from 'react-hooks-use-modal';
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { TailSpin } from 'react-loading-icons';



export const Notification = () => {
  // notification_id取得
  let location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const notification_id = params.notification_id;
  const [notification, setNotification] = useState(location.state === null?[]:location.state.notification);
  // console.log(notification);
  // 戻る
  const back = () => {
    navigate("/notifications");
  };

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });

  // 注文内容の確認へ
   async function nextConfirm () {
    let request_data = {};
    let response_data = await Post('post', '/customer/index.php', request_data);
    const customer = response_data.customer;
    response_data = await Post('post', '/lpspot/index.php', request_data);
    const lpspot = response_data.lpspot;
    const item = {
      id: notification.order.item_id,
      name: notification.order.item_name,
      kin2: notification.order.kin,
      is_syokai: 0,
      type: notification.order.item_type,
      lpspot: lpspot,
    };
    const options = {};
    const quote = {};

    navigate("/confirm", { state: { data:{item,options,customer:customer,quote,lpspot:lpspot,order:notification.order,notification:notification} } });
  }

  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // 注文情報取得
    async function readNotification() {
      openLoadingModal();
      const request_data = {
        'notification_id' : notification_id,
      }
      // post
      const response_data = await Post('post', '/notification/read.php', request_data);
      // 結果
      // console.log(response_data);
      if (response_data.result === 1) {
        // OK
        setNotification(response_data.notification);
        // お知らせ表示の計測（アプリ内・ログイン済み。notification_id で記事を識別）
        Gtag('view_notice', { kind: 'app', notification_id, title: String(response_data.notification?.title || '').slice(0, 60) });
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();
    }
    readNotification();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification_id]);

  return (
    <div className="App">
      <div className="Notification">
        <Analytics title="お知らせ内容" />
        <div className="toolbar">
          <div className="toolbar_left div_btn" onClick={back} >
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            お知らせ内容
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="mt-3 mb-5">
          <div className="order_body mb-3">
            <div className="order_header mb-2">
              <div className="order_date">
                {notification.od_day}
              </div>
            </div>
            <div className="h4 mb-2">
              {notification.title}
            </div>
            <div className="content mb-4 mt-4" style={{ whiteSpace: 'pre-line' }}>
              <LinkifyText text={notification.matter} />
            </div>
            {notification.img !== '' && notification.img !== undefined && (
              <div className="content mb-4 mt-4">
                <img src={notification.img} className="ItemImage" alt="Item" />
              </div>
            )}
          </div>
        </div>
        {notification.od_type==='8' && (
          <>
            {Number(notification.order.otype)===0 ? (
              <div className="flex_div2 border-top">
                <div className="p-2 pb-3">
                  <button className="btn btn-oval btn-yellow form-control" onClick={nextConfirm}>お支払いへ進む</button>
                </div>
              </div>
            ): Number(notification.order.otype)===8 ?(
              <div className="flex_div2 border-top">
                <div className="p-2">
                  お支払いが完了しました。ご対応ありがとうございます。
                </div>
              </div>
            ): Number(notification.order.otype)===11 &&(
              <div className="flex_div2 border-top">
                <div className="p-2">
                  追加決済がキャンセルされました。決済は不要です。
                </div>
              </div>
            )}
          </>
        )}
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
        <Tabbar menu="notifications" />
      </div>
    </div>
  );
}
